
// src/pages/Login.js

import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

import backgroundImage from '../assets/login-background.png';
import logoImage from '../assets/Logo.png';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userRef = doc(db, 'users', user.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const role = data.role;
        localStorage.setItem('userRole', role);

        // 👇 تحديد الفرع تلقائيًا فقط إذا كان الدور "technician"
        if (role === 'technician') {
          const userEmail = user.email.toLowerCase();
          const domain = userEmail.split('@')[1];
          let technicianBranch = '';

          if (domain === 'skymed.ae') {
            technicianBranch = 'Dubai Branch';
          } else if (domain === 'tohrc.ae') {
            technicianBranch = 'Abu Dhabi Branch';
          }

          localStorage.setItem('technicianBranch', technicianBranch); // 👈 تخزين الفرع
        }

        if (['reception', 'supervisor', 'audiology', 'technician'].includes(role)) {
          navigate('/');
        } else {
          setError('Unauthorized role');
        }
      } else {
        setError('User data not found.');
      }
    } catch (err) {
      console.error(err);
      setError('Incorrect email or password.');
      console.log(backgroundImage);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '98vh',
        width: '98vw',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div style={{
        position: 'absolute',
        top: '11px',
        backgroundColor: '#0097a7',
        color: 'white',
        padding: '10px 40px',
        borderRadius: '0 0 25px 25px',
        fontSize: '24px',
        fontWeight: 'bold'
      }}>
        Job Card Record System
      </div>

      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        padding: '2rem',
        borderRadius: '20px',
        boxShadow: '0 0 20px rgba(0,0,0,0.2)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center'
      }}>
        <img src={logoImage} alt="Skymed Logo" style={{ width: '100px', marginBottom: '1rem' }} />

        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Your Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        <button onClick={handleLogin} style={buttonStyle}>
          Login
        </button>
        {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '12px 20px',
  margin: '10px 0',
  borderRadius: '25px',
  border: '1px solid #ccc',
  fontSize: '16px',
  outline: 'none',
  boxSizing: 'border-box'
};

const buttonStyle = {
  width: '100%',
  padding: '12px 20px',
  marginTop: '10px',
  borderRadius: '25px',
  border: 'none',
  backgroundColor: '#0097a7',
  color: 'white',
  fontSize: '16px',
  cursor: 'pointer'
};

export default Login;